import $ from 'jquery';

$(document).ready(function() {
    const $section = $('.seo-performance-growth');
    if (!$section.length) return;

    const $cards = $section.find('.pg-card');

    function updateAccordionBehavior() {
        const isMobile = window.innerWidth <= 768;

        if (isMobile) {
            // On mobile: allow 1 open at a time
            const activeCount = $cards.filter('.active').length;
            if (activeCount > 1) {
                // Keep only the first open
                $cards.filter('.active').not(':first').removeClass('active');
            }
        }
    }

    $cards.on('click', function(e) {
        const $clickedCard = $(this);
        const isMobile = window.innerWidth <= 768;

        // Don't intercept clicks inside actual CTA buttons/links
        if ($(e.target).closest('.btn-pg-send, .btn-pg-arrow').length) {
            return;
        }

        if ($clickedCard.hasClass('active')) {
            $clickedCard.removeClass('active');
        } else {
            if (isMobile) {
                // On mobile: close all others
                $cards.removeClass('active');
                $clickedCard.addClass('active');
            } else {
                // On desktop: 2-column grid (row pairs: 0-1, 2-3, 4-5)
                const clickedIdx = parseInt($clickedCard.data('card-index'), 10);
                const partnerIdx = (clickedIdx % 2 === 0) ? clickedIdx + 1 : clickedIdx - 1;

                // Close all cards NOT in this row pair
                $cards.each(function() {
                    const idx = parseInt($(this).data('card-index'), 10);
                    if (idx !== clickedIdx && idx !== partnerIdx) {
                        $(this).removeClass('active');
                    }
                });

                $clickedCard.addClass('active');
                // Optionally open its partner if both in row should open, or leave partner state
                // To open both cards in the row together:
                $cards.filter(`[data-card-index="${partnerIdx}"]`).addClass('active');
            }
        }
    });

    $(window).on('resize', updateAccordionBehavior);
    updateAccordionBehavior();
});
